<template>
  <div class="flex flex-col">
    <button
      v-for="locale in i18n.global.availableLocales"
      :key="locale"
      role="checkbox"
      class="flex flex-row items-center gap-x-2 py-2"
      :class="{ 'border-b border-grey-100 !py-4': divider }"
      :aria-checked="currentLocale === locale"
      :disabled="currentLocale === locale"
      @click.stop="updateLocale(locale)"
    >
      <gv-icon v-if="leading" name="language" size="xs" class="fill-secondary" />
      <gv-type :id="locale" :text="displayLocale(locale)" breakpoint="none" />
      <input
        :checked="currentLocale === locale"
        type="checkbox"
        class="ml-auto !rounded border-grey-200 !ring-0 transition checked:!bg-emo-deep-blue"
        :aria-labelledby="locale"
        tabindex="-1"
        :disabled="currentLocale === locale"
      />
    </button>
  </div>
</template>
<script setup lang="ts">
import { i18n } from '@/locales';
import localeCode from 'locale-code';
import { computed } from 'vue';

const currentLocale = computed(() => i18n.global.locale.value);

const updateLocale = (localeTag: (typeof i18n.global.availableLocales)[0]) => {
  i18n.global.locale.value = localeTag;
};

const displayLocale = (localeTag: string) => {
  return `${localeCode.getLanguageNativeName(localeTag)} (${localeCode.getCountryName(localeTag)})`;
};

defineProps<{
  leading?: boolean;
  divider?: boolean;
}>();
</script>
